import { useState } from 'react';
import Button from '@/components/Button';
import Dialog from '@/components/Dialog';
import useLogout from '@/hooks/useLogout';

/**
 * Sign Out used to live in the sidebar. On mobile the sidebar is gone and the
 * trigger moves to the Profile screen (DESIGN section 8 -- the one
 * information-architecture change in the mobile layer).
 */
const LogoutButton = ({ className = '' }: { className?: string }) => {
  const { logout, loading } = useLogout();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button color="secondary" className={className} onClick={() => setOpen(true)}>
        Sign Out
      </Button>
      <Dialog
        title="Are you sure?"
        description="The world is not going to end but if you stay your knowledge will be enriched!"
        onAction={logout}
        open={open}
        onClose={() => setOpen(false)}
        cancelText="Stay"
        actionText="Log me out!"
        actionLoading={loading}
      />
    </>
  );
};

export default LogoutButton;
